import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const OCCUPATION_RESTORE_RESOURCE = "occupation" as const;
export const OCCUPATION_RESTORE_API_PATH = `/v1/${OCCUPATION_RESTORE_RESOURCE}/{uuid}/restore` as const;

export type OccupationRestoreResponse =
  paths[typeof OCCUPATION_RESTORE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useOccupationRestoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<OccupationRestoreResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<OccupationRestoreResponse>(
        `/v1/${OCCUPATION_RESTORE_RESOURCE}/${uuid}/restore`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [OCCUPATION_RESTORE_RESOURCE],
      });
    },
  });
};
